import React, { Component } from 'react';
import { Select } from 'antd';

import { StyledSelect } from 'components/Styled';
import states from 'data/states';

const { Option } = Select;

class StateSelect extends Component {
  render() {
    return (
      <StyledSelect
        size="large"
        placeholder={this.props.t('common.select')}
        value={this.props.value || undefined}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}>
        {states[this.props.country].map(state => (
          <Option key={state.code}>{state.name}</Option>
        ))}
      </StyledSelect>
    );
  }
}

export default StateSelect;
